import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import reduxThunk from "redux-thunk";
import Amplify from "aws-amplify";
import { Hub } from "aws-amplify";
import { listener } from "./components/auth/NewUserColumnSet";
import App from "./components/App";
import reducers from "./redux/reducers";
import awsconfig from "./aws-exports";
import { Router } from "react-router-dom";
import "./index.css";
import history from "./history";

Amplify.configure(awsconfig);

Hub.listen("auth", listener);
// window.LOG_LEVEL='DEBUG';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(reduxThunk))
);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.querySelector("#root")
);
